import { getFirestore, collection, addDoc, getDocs, deleteDoc, doc, query, where } from 'firebase/firestore';
import { getFirebaseApp } from './firebaseConfig';

const db = getFirestore(getFirebaseApp());
const brandsCollection = collection(db, 'brands');

export async function addBrandToFirestore(name, uid) {
  const docRef = await addDoc(brandsCollection, { name, uid });
  return docRef.id;
}

export async function getBrandsFromFirestore(uid) {
  let q = brandsCollection;
  if (uid) {
    q = query(brandsCollection, where('uid', '==', uid));
  }
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

export async function deleteBrandFromFirestore(id) {
  await deleteDoc(doc(brandsCollection, id));
}
